/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuoteResponseDto } from '../../models/sales-quote-response-dto';
import { SalesVacationItemDto } from '../../models/sales-vacation-item-dto';

export interface QuotesControllerAddVacationItem$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the quote.
 */
  quoteId: string;
      body: SalesVacationItemDto
}

export function quotesControllerAddVacationItem(http: HttpClient, rootUrl: string, params: QuotesControllerAddVacationItem$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, quotesControllerAddVacationItem.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('quoteId', params.quoteId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesQuoteResponseDto>;
    })
  );
}

quotesControllerAddVacationItem.PATH = '/o2-sales/quotes/{tenant}/{quoteId}/vacation-items';
